/**
 * Shared constants for the spatial scene.
 *
 * Layout philosophy
 * - All zones are arranged along a -Z corridor so the non-XR camera can
 *   simply translate forward as the user scrolls. Rooms are gently offset
 *   left/right to give the corridor "shape" without losing the linear path.
 * - Camera eye height is 1.6m — matches Vision Pro / Quest 3 default.
 * - In XR, the user free-walks the same corridor; the spawn anchor is the
 *   hero zone and a teleport target sits at each stop for fast travel.
 */
export const BEBAS_FONT_URL =
  "https://fonts.gstatic.com/s/bebasneue/v14/JTUSjIg69CK48gW7PXoo9WlhyyTh89Y.woff";

/**
 * Each zone is a "rest" position for the camera and the lookAt target it
 * faces while at rest. The order matches scroll order on web.
 */
export const ZONES = {
  hero:       { position: [0,    1.6, 5],   lookAt: [0,    1.6, -2] },
  presale:    { position: [0,    1.6, -8],  lookAt: [-3,   1.6, -14] },
  tokenomics: { position: [0,    1.6, -22], lookAt: [3,    1.6, -28] },
  staking:    { position: [0,    1.6, -36], lookAt: [0,    1.6, -44] },
  roadmap:    { position: [0,    1.8, -50], lookAt: [0,    1.4, -62] },
  footer:     { position: [0,    1.6, -68], lookAt: [0,    1.6, -76] },
} as const satisfies Record<string, { position: readonly [number, number, number]; lookAt: readonly [number, number, number] }>;

export type ZoneId = keyof typeof ZONES;
export const ZONE_ORDER: ZoneId[] = ["hero", "presale", "tokenomics", "staking", "roadmap", "footer"];

/** Where the actual content of each zone is anchored (world coords). */
export const ZONE_ANCHORS: Record<ZoneId, [number, number, number]> = {
  hero:       [0,   1.6, -2],
  presale:    [-3.2, 1.4, -14],
  tokenomics: [3.2, 1.6, -28],
  staking:    [0,   1.4, -44],
  roadmap:    [0,   1.4, -58],
  footer:     [0,   1.4, -76],
};
